import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Injector} from '@angular/core';
import { GenerateTokenService, Token } from 'integrationpingid-lib';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout } from 'rxjs/operators';

import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { NotificationService} from "../shared/notification/notification.service";
import { DialogsService} from "../shared/dialogs.service";
import { ConfirmationDialogService} from "../shared/confirmation-dialog/confirmation-dialog.service";
import { AuditService } from "../shared/audit/audit.service";

@Injectable({
  providedIn: 'root'
})
export class TradeService {

  serviceName = "TradeService";
  objParams = {
    headers: this.getTokenToHeaders()
  };
  COUNTRY: string = "RD";
  DOMAIN: string = "DO_CREDIT";
  SOURCE: string = "TRADE";

  usuarioSoftDelete = this.localStorageService.dataLogin.getUser();
  private notificationService: NotificationService;
  private dialogo: DialogsService;
  private confirmationDialogService: ConfirmationDialogService;
  private auditService: AuditService;

  constructor(
    private http: HttpClient,
    public serviceToken: GenerateTokenService,
    private localStorageService: LocalStorageService,
    injector: Injector
  ) {
    this.notificationService = injector.get<NotificationService>(NotificationService);
    this.dialogo = injector.get<DialogsService>(DialogsService);
    this.confirmationDialogService = injector.get<ConfirmationDialogService>(ConfirmationDialogService);
    this.auditService = injector.get<AuditService>(AuditService);
  }

  getTokenToHeaders() {
    console.log('getTokenToHeaders');
    let headerDict: { Authorization: string; };
    if (this.localStorageService.getIsVip) {
      headerDict = {
        Authorization: "Bearer " + localStorage.getItem('access_token')
      };
    } else {
      let token: Token = {};
      if (this.serviceToken.statusTokenUser()) {
        token = this.serviceToken.getTokenUser();
      } else {
        // This is intentional
      }
      headerDict = {
        Authorization: token.token_type + " " + token.access_token,
      };
    }
    return headerDict;
  }

  getTradeList(nationalIdHash: any): Observable<any> {
    console.log('getSicomSummaryList', nationalIdHash);
    const param = new HttpParams().set('matchkey', nationalIdHash + '.');
    const objParams = {
      headers: this.getTokenToHeaders(),
      params: param
    };

    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";

    const consumerAPI = environment.CONSUME_API_DATA.toString().toLowerCase() === "true";

    let urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_OKTA_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

    const url = consumerAPI ?
      `${urlBaseApi}${rutaMicroservicio}/api/v4/sources/RD/DO_CREDIT/TRADE` :
      `assets/mock/py/preview/PREVIEW2_V4.json`;

    console.log(`[${this.serviceName}] getTradeList - URL:`, url);
    console.log(`[${this.serviceName}] getTradeList - Params:`, param.toString());

    return this.http.get(
      url, objParams
    ).pipe(
      timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
    );
  }

  getTradeListHistory(fullMatchKey: string): Observable<any> {
    console.log('getSicomSummaryListHistory', fullMatchKey);
    const params = new HttpParams().set('matchkey', fullMatchKey);

    const objParams = {
      headers: this.getTokenToHeaders(),
      params: params
    };

    const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";

    const consumerAPI = environment.CONSUME_API_DATA.toString().toLowerCase() === "true";

    const urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_OKTA_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

    const API_VERSION = 'v2';
    const ENDPOINT = 'sources/history';
    const DOMAIN_INFO = 'RD/DO_CREDIT/TRADE';

    const url = consumerAPI ?
      `${urlBaseApi}${rutaMicroservicio}/api/${API_VERSION}/${ENDPOINT}/${DOMAIN_INFO}` :
      `assets/mock/py/preview/PREVIEW2_HISTORY.json`;

    console.log(`[${this.serviceName}] getTradeListHistory - URL:`, url);
    console.log(`[${this.serviceName}] getTradeListHistory - Params:`, params.toString());

    // 5. Realizar la llamada GET.
    return this.http.get(url, objParams).pipe(
      timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
    );
  }

  public getTradeListPeriods(nationalIdHash: any): Observable<any> {
    const params = new HttpParams().set('matchkey', nationalIdHash).set('periodName', 'consolidationDate');
    const objParams = {headers: this.getTokenToHeaders(), params: params};
    const urlBaseApi = (this.localStorageService.getIsVip)
      ? environment.VIP_URL_BASE_API
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + (this.localStorageService.getIsVip
      ? 'vip/journaling-service'
      : this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"])
      : "";
    const API_VERSION = (this.localStorageService.getIsVip)
      ? 'v1'
      : 'api/v1';
    const ENDPOINT_PERIODS = 'sources/periods';
    const COUNTRY_DOMAIN_SUBDOMAIN = this.COUNTRY + '/' + this.DOMAIN + '/' + this.SOURCE + '';

    const url = environment.CONSUME_API_DATA.toString().toLowerCase() === "true"
      ? `${urlBaseApi}${rutaMicroservicio}/${API_VERSION}/${ENDPOINT_PERIODS}/${COUNTRY_DOMAIN_SUBDOMAIN}`
      : `assets/mock/py/preview/PERIOD_PREVIEW.json`
    if (this.localStorageService.getIsVip) {
      const sMatrizVip = {
        'field': 'affiliateIdNumber',
        'matriz': this.localStorageService.getMatrizArray
      }
      return this.http.post(
        url, sMatrizVip, objParams
      ).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)))
    } else {
      return this.http.get(url, objParams).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    }
  }

  createListToDisplay(listPayload) {
    console.log('createListToDisplay', listPayload);
    let rows = [];
    for (const key in listPayload.payload) {
      let currentType = listPayload.payload[key];
      currentType.forEach(element => {
        let newRow = element;
        rows.push(newRow)
      });
    }
    return rows;
  }

  filterDataTrade(dataDetalle, tradeObject: any) {
    console.log('filterDataSicomSummary', dataDetalle, tradeObject);
    let rows = [];
    for (const key in dataDetalle.payload) {
      let currentType = dataDetalle.payload[key];
      currentType.forEach(element => {
        if (element.accountNumber == tradeObject.accountNumber) {
          let newRow = element;
          rows.push(newRow)
        }
      });
    }
    return rows;
  }

  getDetails(tradeObject: any, codmoneda?: string) {
    console.log('getDetails', tradeObject, codmoneda);
    const urlBaseApi = (this.localStorageService.getIsVip) ?
      this.localStorageService.configInit["F_OKTA_URL_BASE_API"] :
      this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const country = "RD";
    const subDomain = "DO_CREDIT/TRADE";
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";

    const param = new HttpParams().set('matchkey', String(tradeObject.matchKey).slice(0, -7));
    const objParams = {
      headers: this.getTokenToHeaders(),
      params: param
    };

    let paramTradeMoneda = {
      "params": {
        "currencyCode": codmoneda
      }
    }

    const consumerAPI = environment.CONSUME_API_DATA.toString().toLowerCase() === "true";

    // if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
    const urlData = `assets/data/rd/detail/DATA_DETAIL_TRADE.json`;
    if (codmoneda != "") {
      const url = consumerAPI ?
        `${urlBaseApi}${rutaMicroservicio}/api/v3/sources/details/filter/${country}/${subDomain}` :
        urlData;
      return this.http.post(
        url, paramTradeMoneda, objParams
      ).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
      )
    } else {
      const url = consumerAPI ?
        `${urlBaseApi}${rutaMicroservicio}/api/v3/sources/details/${country}/${subDomain}` :
        urlData;
      return this.http.get(
        url, objParams
      ).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
      )
    }
  }

  updateDisRD(source: string, _form: FormGroup, dataToSave: any, service?: any) {
    console.log('updateDisRD', source, _form, dataToSave, service);
    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      let urlBaseApi = (this.localStorageService.getIsVip)
        ? this.localStorageService.configInit["F_OKTA_URL_BASE_API"]
        : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
      let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
        ? "/" + this.localStorageService.configInit["F_URL_MS_IM_DIS"]
        : "";
      return this.http.post<any>(
        `${urlBaseApi}${rutaMicroservicio}/api/v2/DIS/RD/${source}`, {"data": dataToSave}, this.objParams)
        .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        );
    } else {
      return of({"type": "mockResponse", "data": dataToSave, service});
    }
  }

  public postDisPayloadRD(source: string, payload: any, service?: any): Observable<any> {
    const urlBaseApi = (this.localStorageService.getIsVip)
      ? environment.VIP_URL_BASE_API
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + (this.localStorageService.getIsVip
      ? 'vip/journaling-service'
      : this.localStorageService.configInit["F_URL_MS_IM_DIS"])
      : "";
    const API_VERSION = this.localStorageService.getIsVip
      ? 'v2'
      : 'api/v2';

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      return this.http.post<any>(
        `${urlBaseApi}${rutaMicroservicio}/${API_VERSION}/DIS/RD/${source}`,
        payload, {
          headers: this.getTokenToHeaders()
        }).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    } else {
      return of({ "type": "mockResponse", "data": payload, service });
    }
  }

  getMonedaList() {
    return MONEDA_LIST;
  }

  getStatusList() {
    return STATUS_LIST;
  }

  getTypeCode() {
    return TYPE_CODE;
  }

  getCloseCuenta() {
    return CLOSE_CODE;
  }

  deleteSource(source: string, parammatchKey, paramsubDominio, countryDelete) {
    console.log('deleteSource', source, parammatchKey, paramsubDominio, countryDelete);
    const objParams = {
      headers: this.getTokenToHeaders()
    };

    let params = JSON.parse(JSON.stringify(objParams));
    let matchKey = "";
    const dataToDelete = {
      observations: {},
      internalOp: "SOFT_DELETE",
    };

    matchKey = "isEqual('ingestionHeader.matchKey'," + "'" + parammatchKey.slice(0, -7) + "')";
    dataToDelete.observations = ({ matchKey });

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_DMS"]
      : "";

    const baseUrl = (this.localStorageService.getIsVip)
      ? `${this.localStorageService.configInit["F_OKTA_URL_BASE_API"]}/api-vip/dms-service`
      : `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}${rutaMicroservicio}/api`;
    // ruta VIP

    return this.http.post<any>(`${baseUrl}/v1/dms/${countryDelete.toUpperCase()}/${source}/${paramsubDominio}/${this.usuarioSoftDelete}`, dataToDelete, params)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  //todo: obtener esto desde la configuracion o servico
  public getTradeFieldDefinitions(): any[] {
    console.log("TradeService: Proveyendo definiciones de campos...");
    return [
      // == Sección: Identificación ==
      { name: 'affiliateIdNumber',       label: 'Número de afiliado',        section: 'Identificación', editable: false, visible: true,  inputType: 'text',   pattern: null, nullable: false, order: 1,  columnOrder: 1, preview1: true,  preview2: false },
      { name: 'accountNumber',           label: 'Número de cuenta',          section: 'Identificación', editable: false, visible: true,  inputType: 'text',   pattern: null, nullable: false, order: 2,  columnOrder: 2, preview1: true,  preview2: false },
      { name: 'consolidationDate',       label: 'Mes de consolidación',      section: 'Identificación', editable: false, visible: true,  inputType: 'text',   pattern: null, nullable: true,  order: 3,  columnOrder: 1, preview1: false, preview2: true },

      // == Sección: Crédito ==
      { name: 'productTypeCode',         label: 'Producto',                  section: 'Crédito',        editable: false, visible: true,  inputType: 'text',   pattern: null, nullable: true,  order: 4,  columnOrder: 3, preview1: true,  preview2: false },
      { name: 'currencyCode',            label: 'Moneda',                    section: 'Crédito',        editable: false, visible: true,  inputType: 'text',   pattern: null, nullable: true,  order: 5,  columnOrder: 3, preview1: false, preview2: true },
      { name: 'accountOpeningDate',      label: 'Fecha apertura',            section: 'Crédito',        editable: false,  visible: true,  inputType: 'date',   pattern: null, nullable: true,  order: 6,  columnOrder: 4, preview1: true,  preview2: false },
      { name: 'creditApprovedAmount',    label: 'Crédito aprobado',          section: 'Crédito',        editable: false,  visible: true,  inputType: 'text',   pattern: null, nullable: true,  order: 7,  columnOrder: 6, preview1: true,  preview2: true },
      { name: 'opTypeCode',              label: 'Excluir',                   section: 'Crédito',        editable: true,  visible: true,  inputType: 'select', pattern: null, nullable: true,  order: 8,  columnOrder: 2, preview1: false, preview2: true, options: [{ code: '1', description: 'SI' }, { code: '0', description: 'NO' }, { code: '', description: '-' }] },
      { name: 'accountStatusCode',       label: 'Último estatus',            section: 'Crédito',        editable: true,  visible: true,  inputType: 'select', pattern: null, nullable: true,  order: 9,  columnOrder: null,preview1: false, preview2: false, options: this.getStatusList()},
      { name: 'accountLastActivityDate', label: 'Fecha última transacción',  section: 'Crédito',        editable: false,  visible: true,  inputType: 'date',   pattern: null, nullable: true,  order: 10, columnOrder: 5, preview1: true,  preview2: false },
      { name: 'accountBalance',          label: 'Balance actual',            section: 'Crédito',        editable: false,  visible: true,  inputType: 'text',   pattern: null, nullable: true,  order: 11, columnOrder: null,preview1: false, preview2: false },
      { name: 'masterAccountStatusCode', label: 'Cierre de cuenta',          section: 'Crédito',        editable: true,  visible: true,  inputType: 'select', pattern: null, nullable: true,  order: 12, columnOrder: null,preview1: false, preview2: false, options: this.getCloseCuenta()},

      // == Sección: Atrasos ==
      { name: 'mandatoryFees',           label: 'Cuota',                     section: 'Atrasos',        editable: false,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 13, columnOrder: 5, preview1: false, preview2: true },
      { name: 'totalDelayAmount',        label: 'Monto en atraso',           section: 'Atrasos',        editable: false,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 14, columnOrder: 6, preview1: false, preview2: true },
      { name: 'pendingFeesAmount',       label: 'Cant. cuotas atrasadas',    section: 'Atrasos',        editable: false,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 15, columnOrder: 7, preview1: false, preview2: true },
      { name: 'delay30TotalAmount',      label: 'PDV1',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 16, columnOrder: 8, preview1: false, preview2: true },
      { name: 'delay60TotalAmount',      label: 'PDV2',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 17, columnOrder: 9, preview1: false, preview2: true },
      { name: 'delay90TotalAmount',      label: 'PDV3',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 18, columnOrder: 10,preview1: false, preview2: true },
      { name: 'delay120TotalAmount',     label: 'PDV4',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 19, columnOrder: 11,preview1: false, preview2: true },
      { name: 'delay150TotalAmount',     label: 'PDV5',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 20, columnOrder: 12,preview1: false, preview2: true },
      { name: 'delay180TotalAmount',     label: 'PDV6',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 21, columnOrder: 13,preview1: false, preview2: true },
      { name: 'delay210TotalAmount',     label: 'PDV7',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 22, columnOrder: 14,preview1: false, preview2: true },
      { name: 'delay240TotalAmount',     label: 'PDV8',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 23, columnOrder: 15,preview1: false, preview2: true },
      { name: 'delay270TotalAmount',     label: 'PDV9',                      section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 24, columnOrder: 16,preview1: false, preview2: true },
      { name: 'delay300TotalAmount',     label: 'PDV10',                     section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 25, columnOrder: 17,preview1: false, preview2: true },
      { name: 'delay330TotalAmount',     label: 'PDV11',                     section: 'Atrasos',        editable: true,  visible: false, inputType: 'text',   pattern: null, nullable: true, order: 26, columnOrder: 18,preview1: false, preview2: true },
    ];
  }

  async showTradeMassiveEdit(
    currentView: any,
    selected: any[],
    currentHistoryMatchKey: string,
    lastPreview1Selection: any,
    reloadPreviewCallback: (selection: any) => void,
    avroSchema: any[]
  ): Promise<void> {

    console.log("TradeService: Iniciando lógica de edición masiva para TRADE");

    if (currentView !== 'preview2' || selected.length === 0) {
      this.notificationService.showInfo('Por favor, seleccione al menos un registro para la edición masiva.');
      return;
    }

    const editableFields = this.getTradeFieldDefinitions()
      .filter(field => field.editable);

    const config = {
      height: 'auto',
      width: '650px',
      data: {
        title: 'Edición Masiva (TRADE)',
        message: 'Seleccione las acciones que desea aplicar a los registros marcados:',
        availableFields: editableFields
      }
    };

    // Agregar un pequeño delay para permitir que Angular complete el ciclo de detección
    await new Promise(resolve => setTimeout(resolve, 100));

    const res = await this.dialogo.muestraMensajeTrade('message', config);

    if (res && res.status) {
      const confirmed = await this.confirmationDialogService.confirmActionWithComment(
        'Modificación Masiva',
        '¿Desea confirmar la edición masiva de los registros seleccionados?'
      );

      if (confirmed) {
        // Mostramos una notificación de "cargando"
        //const loadingNotification = this.notificationService.showLoading('Procesando edición masiva...'); //todo: Buscar como hacer esto

        // Llamamos al servicio para que construya y envíe el payload
        this.buildAndSendDisPayload(
          res,
          selected,
          currentHistoryMatchKey,
          avroSchema
        ).subscribe({
          next: (serviceRes) => {
            // loadingNotification.close(); // Cerramos la notificación de carga //todo: Buscar como hacer esto
            if (serviceRes) {
              this.notificationService.showSuccess('La edición masiva se solicitó correctamente.');
              if (lastPreview1Selection) {
                // Usamos el callback para recargar la vista en el componente padre
                reloadPreviewCallback(lastPreview1Selection);
              }
            }
          },
          error: (err) => {
            //loadingNotification.close(); // Cerramos la notificación de carga //todo: Buscar como hacer esto
            this.notificationService.showError('Ocurrió un error en la edición masiva.');
            console.error(err);
          }
        });
      }
    }
  }

  public buildAndSendDisPayload(
    edits: { balancesCero: boolean, contadoresCero: boolean, detailedEdits: any },
    selectedItems: any[],
    currentHistoryMatchKey: string,
    avroSchema: any[]
  ): Observable<any> {

    const itemsToUpdate = JSON.parse(JSON.stringify(selectedItems));

    if (itemsToUpdate.length === 0) {
      if(this.notificationService) {
        this.notificationService.showInfo('No se seleccionaron registros para actualizar.');
      } else {
        console.warn('No se seleccionaron registros para actualizar.');
      }
      return of(null);
    }

    const dataArray = itemsToUpdate.map(item => {
      if (edits.contadoresCero) {
        Object.keys(item).forEach(key => {
          if (key.startsWith('delay') && key.endsWith('TotalAmount')) {
            item[key] = "0";
          }
        });
        item.additionalStatus = "1";
      }
      if (edits.balancesCero) {
        item.totalDelayAmount = "0";
      }
      Object.assign(item, edits.detailedEdits);

      const formattedItem = this.disObjectCreator(item, avroSchema);
      return JSON.stringify(formattedItem);
    });

    const auditData = this.auditService.buildAuditForMassiveTrade(selectedItems[0], edits, currentHistoryMatchKey);
    const payload = { data: dataArray, audit: auditData };

    return this.postDisPayloadRD("DO_CREDIT/TRADE", payload, "TRADE");
  }


  public disObjectCreator(tempItem: any, avroSchema: any[]): any {
    const source = "TRADE";
    const actualObject = {};
    const dataview = avroSchema;
    if (!dataview) {
      console.error(`No se encontró la definición de DATAVIEWS para la fuente: ${source}`);
      return tempItem;
    }

    const addressDef = dataview.find(def => def.name === 'personAddresses');
    const addressFields = (addressDef && !Array.isArray(addressDef.type) && addressDef.type.type === 'array' && typeof addressDef.type.items === 'object')
      ? addressDef.type.items.fields
      : undefined;

    const phoneDef = dataview.find(def => def.name === 'personPhones');
    const phoneFields = (phoneDef && !Array.isArray(phoneDef.type) && phoneDef.type.type === 'array' && typeof phoneDef.type.items === 'object')
      ? phoneDef.type.items.fields
      : undefined;

    Object.keys(dataview).forEach(key => {
      const itemStructure = dataview[key];
      const fieldName = itemStructure.name;
      if (this.validateKeying(itemStructure)) {
        actualObject[fieldName] = [];
        return;
      }

      if (tempItem.hasOwnProperty(fieldName) && tempItem[fieldName] !== null) {
        const value = tempItem[fieldName];

        if (Array.isArray(itemStructure.type)) {
          const type = this.getItemType(itemStructure.type);
          actualObject[fieldName] = { [type]: value };

        } else if (itemStructure.type.type === 'array') {
          let arrayFieldsDefinition = null;

          if (itemStructure.type.items && typeof itemStructure.type.items === 'object' && itemStructure.type.items.fields) {
            arrayFieldsDefinition = itemStructure.type.items.fields;
          } else if (typeof itemStructure.type.items === 'string') {
            if (itemStructure.type.items.includes('Address') && addressFields) {
              arrayFieldsDefinition = addressFields;
            } else if (itemStructure.type.items.includes('Phone') && phoneFields) {
              arrayFieldsDefinition = phoneFields;
            }
          }

          const arrayValue = Array.isArray(value) ? value : [];

          if (arrayFieldsDefinition) {
            actualObject[fieldName] = this.createObjectDISArray(arrayValue, arrayFieldsDefinition);
          } else {
            actualObject[fieldName] = arrayValue;
          }
        } else {
          const type = itemStructure.type;
          actualObject[fieldName] = { [type]: value };
        }

      } else {
        actualObject[fieldName] = null;
      }
    });
    return actualObject;
  }

  private validateKeying(itemStructure: any): boolean {
    return itemStructure.name === "keying";
  }

  private getItemType(typesArray: any[]): string {
    const typeObject = typesArray.find(element => element !== "null");
    return typeObject ? (typeObject.type || typeObject) : "string";
  }

  createObjectDISArray(value: any[], fieldDefinitions: any[] | null): any[] {
    console.log('createObjectDISArray', value, fieldDefinitions);

    if (!Array.isArray(value)) {
      return value;
    }

    if (value.length === 0 && fieldDefinitions) {
      const defaultObject = {};

      fieldDefinitions.forEach(field => {
        const type = this.getItemType(field.type);
        defaultObject[field.name] = { [type]: "" };
      });

      return [defaultObject];
    }

    return value.map(dataItem => {
      if (typeof dataItem !== 'object' || dataItem === null) {
        return dataItem;
      }
      const newObj = {};
      Object.keys(dataItem).forEach(key => {
        const fieldValue = dataItem[key];
        if (fieldValue !== null && fieldValue !== undefined) {
          const fieldSchema = fieldDefinitions ? fieldDefinitions.find(f => f.name === key) : null;
          const type = fieldSchema ? this.getItemType(fieldSchema.type) : 'string';
          newObj[key] = { [type]: fieldValue };
        } else {
          newObj[key] = null;
        }
      });
      return newObj;
    });
  }

}

const MONEDA_LIST = [
  { code: "DO", description: "DO$ PESO[Rep. Dominicana] " },
  { code: "DO ", description: "DO $ PESO[Rep. Dominicana con espacio] " },
  { code: "RD", description: "RD$ PESO[Rep. Dominicana] " },
  { code: "US", description: "US$ DOLAR[Estados Unidos]" },
  { code: "US ", description: "US $ DOLAR[Estados Unidos con espacio]" },
];

const STATUS_LIST = [
  { code: "", description: "--" },
  { code: "Normal", description: "Normal" },
  { code: "Activa", description: "Activa" },
  { code: "Vigente", description: "Vigente" },
  { code: "Mora", description: "Mora" },
  { code: "Cuenta Cancelada", description: "Cuenta Cancelada" },
  { code: "Legal", description: "Legal" },
  { code: "Castigado", description: "Castigado" },
  { code: "RECHAZADO", description: "RECHAZADO" },
  { code: "IMPUGNADO", description: "IMPUGNADO" },
  { code: "APROBADO", description: "APROBADO" },
];

const TYPE_CODE = [
  { code: "0", description: "NO" },
  { code: "1", description: "SI" }
];

const CLOSE_CODE = [
  { code: "N", description: "CUENTA CERRADA" },
  { code: "-", description: "-" }
];
